import { getCurrentSession } from '@/utils/supabaseAuth';
import { isJwtTokenFresh } from '@/utils/jwt';

const CHECK_LOGIN_SESSION_TIMEOUT_MS = 1500;

async function getSessionWithTimeout() {
  return Promise.race([
    getCurrentSession(),
    new Promise<null>((resolve) => {
      window.setTimeout(() => resolve(null), CHECK_LOGIN_SESSION_TIMEOUT_MS);
    }),
  ]);
}

/**
 * 检查登录状态
 * 优先检查 Supabase session，如果没有则检查 localStorage
 */
export default async function checkLogin(): Promise<boolean> {
  try {
    // 首屏优先使用本地登录态，但要求 token 未过期
    const localStatus = localStorage.getItem('userStatus');
    const localToken = localStorage.getItem('token');
    if (localStatus === 'login' && isJwtTokenFresh(localToken)) {
      return true;
    }

    // 检查 Supabase session
    const session = await getSessionWithTimeout();
    if (session?.user) {
      return true;
    }

    // 降级检查 localStorage（兼容旧逻辑）
    return localStatus === 'login' && isJwtTokenFresh(localToken);
  } catch (error) {
    console.error('检查登录状态错误:', error);
    const localStatus = localStorage.getItem('userStatus');
    const localToken = localStorage.getItem('token');
    return localStatus === 'login' && isJwtTokenFresh(localToken);
  }
}
